import main from '@/main.js'

const Cart = {
  install (Vue, options = {}) {
    Vue.prototype.$cart = {
      init: function (vm) {
        vm.cart = this.get(vm)
      },
      // get cart
      get: function (vm) {
        // vm.$session.set('cart', "")
        let cart = vm.$session.get('cart')
        if (!cart || vm.empty(cart)) {
          cart = {
            'uuid': '',
            'customer_id': null,
            'tax_percent': 0,
            'tax_total': 0,
            'total': 0,
            'sub_total': 0,
            'data': []
          }
        }
        return cart
      },
      getDetail: function (vm) {
        let cart = this.get(vm)
        let self = this

        if (cart.uuid) {
          let data = {'cart_id': cart.uuid}
          vm.axios.apiCart.getCart(data,
            function (response) {
              cart = response.data.data.item
              self.commit(vm, cart)
            }, function (error) {
              self.commit(vm, {})
            }
          )
        }
      },
      // insert item cart
      insert: function (vm, item, callBackError) {
        let cart = this.get(vm)
        let self = this
        let isFirstAddCart = false

        if (cart.uuid) {
          item.group.cart_id = cart.uuid
        } else {
          isFirstAddCart = true
        }

        if (cart.hasOwnProperty('is_use_cutlery')) {
          item.group.require_cutlery = cart.is_use_cutlery
        }

        item.group.advance_order = vm.$disposition.getByKey(vm, 'advanceOrder', 0)
        item.group.address_code = vm.$disposition.getByKey(vm, 'addressCode', '')
        item.group.order_time = vm.convertDateTimeToUTC(item.group.order_time)

        // Send to API
        // Received response from API and set for cart
        var title = vm.$t('cart.add_success')
        var message = vm.$t('cart_invalid_selling_time_cus')
        var message1 = vm.$t('cart_invalid_lunch_time')
        var message2 = vm.$t('cart_invalid_hut_day')
        var message3 = vm.$t('cart_invalid_order_time')
        var message4 = vm.$t('cart_invalid_open_time')
        var message5 = vm.$t('cart_invalid_min_cart')
        var message6 = vm.$t('cart_empty')
        var message7 = vm.$t('cart_invalid_current_order_time')
        var message8 = vm.$t('cart_unable_purchase_specified_time')
        vm.axios.apiCart.addToCart(item,
          function (response) {
            cart = response.data.data.item
            self.commit(vm, cart)
            vm.$notify({
              type: 'success',
              title: title
            })
            if (isFirstAddCart) {
              self.insertPlasticBag(vm, callBackError)
            }
            isFirstAddCart = false
          }, function (data) {
            if (callBackError) {
              callBackError()
            }
            switch (data.error.code) {
              case vm.$const.CART_CODE.SELLINGTIME:
                vm.$notify({
                  type: 'error',
                  title: message
                })
                break
              case vm.$const.CART_CODE.INVALIDHUTDAY:
                vm.$notify({
                  type: 'error',
                  title: message2
                })
                break
              case vm.$const.CART_CODE.INVALIDLUNCHTIME:
                vm.$notify({
                  type: 'error',
                  title: message1
                })
                break
              case vm.$const.CART_CODE.NOTFOUND:
                self.commit(vm, [])
                vm.$root.$emit('onRedirectToHome')
                break
              case vm.$const.CART_CODE.INVALIDORDERTIME:
                vm.$notify({
                  type: 'error',
                  title: message3
                })

                vm.callEventBus(vm.$const.EVENT_BUS.SHOW_ASAP, true)
                break
              case vm.$const.CART_CODE.INVALIDOPENTIME:
                vm.$notify({
                  type: 'error',
                  title: message4
                })

                vm.callEventBus(vm.$const.EVENT_BUS.SHOW_ASAP, true)
                break
              case vm.$const.CART_CODE.INVALIDMINCART:
                vm.$notify({
                  type: 'error',
                  title: message5
                })
                break
              case vm.$const.CART_CODE.EMPTYCART:
                vm.$notify({
                  type: 'error',
                  title: message6
                })
                break
              case vm.$const.CART_CODE.INVALIDCURRENTORDERTIME:
                vm.$notify({
                  type: 'error',
                  title: message7
                })

                vm.callEventBus(vm.$const.EVENT_BUS.SHOW_ASAP, true)
                break
              case vm.$const.CART_CODE.INVALID_PURCHASE_SPECIFIED_TIME:
                vm.$notify({
                  type: 'error',
                  title: message8
                })
                break
              default:
                break
            }
          }
        )
      },
      // insert plastic bag cart
      insertPlasticBag: function (vm, callBackError) {
        let cart = this.get(vm)
        let self = this
        let data = vm.$session.get('plasticBags')
        let orderTime = vm.convertDateTimeFromTimezoneToUTC(vm.$disposition.getByKey(vm, 'timezone', ''), vm.$disposition.getByKey(vm, 'collectionTimeValue', ''))
        if (!orderTime) {
          orderTime = vm.$moment().utc().format('YYYY-MM-DD HH:mm:ss')
        }
        let item = {
          'group': {},
          'products': []
        }
        item.group['cart_id'] = cart.uuid
        item.group['outlet_code'] = vm.$disposition.getByKey(vm, 'outletCode', '')
        item.group['address_code'] = vm.$disposition.getByKey(vm, 'addressCode', '')
        item.group['tier'] = vm.$disposition.getByKey(vm, 'tier', '')
        item.group['order_type'] = vm.$disposition.getByKey(vm, 'orderType', '').charAt(0)
        item.group['order_time'] = orderTime
        item.group['product_type'] = vm.$const.CARD_ITEM_TYPE.SINGLE
        item.group['combo_id'] = ''
        item.group['quantity'] = 1
        
        item.selling_start = data.selling_start
        
        let products = {}
        products.category_id = data.category_id
        products.combo_group_id = null
        products.product_id = data.uuid
        products.first_id = ""//this.choosedFirst.uuid
        products.second_id = ""//this.choosedSecond.uuid
        products.toppings = {}
        products.toppings.remove = [] //this.$cart.getToppingById(this.removeYourTopping)
        products.toppings.extra = [] //this.$cart.getToppingById(this.addExtraTopping)
        item.products.push(products)

        vm.axios.apiCart.addToCart(item,
          function (response) {
            cart = response.data.data.item
            console.log('axios.apiCart.addToCart plasticBags ', cart);
            self.commit(vm, cart)
          }, function (data) {
            if (callBackError) {
              callBackError()
            }
          }
        )
      },
      updateCart: function (vm, item) {
        let cart = this.get(vm)
        let self = this

        if (cart.uuid) {
          item.group.cart_id = cart.uuid
        }

        if (cart.hasOwnProperty('is_use_cutlery')) {
          item.group.require_cutlery = cart.is_use_cutlery
        }

        item.group.advance_order = vm.$disposition.getByKey(vm, 'advanceOrder', 0)
        item.group.address_code = vm.$disposition.getByKey(vm, 'addressCode', '')
        item.group.order_time = vm.convertDateTimeToUTC(item.group.order_time)

        // Send to API
        // Received response from API and set for cart
        var title = vm.$t('cart.update_success')
        var message = vm.$t('cart_invalid_selling_time_cus')
        var message1 = vm.$t('cart_invalid_lunch_time')
        var message2 = vm.$t('cart_invalid_hut_day')
        var message3 = vm.$t('cart_invalid_order_time')
        var message4 = vm.$t('cart_invalid_open_time')
        var message5 = vm.$t('cart_invalid_min_cart')
        var message6 = vm.$t('cart_empty')
        var message7 = vm.$t('cart_invalid_current_order_time')
        vm.axios.apiCart.updateItemCart(item,
          function (response) {
            cart = response.data.data.item
            self.commit(vm, cart)
            vm.$notify({
              type: 'success',
              title: title
            })
          }, function (data) {
            switch (data.error.code) {
              case vm.$const.CART_CODE.SELLINGTIME:
                vm.$notify({
                  type: 'error',
                  title: message
                })
                break
              case vm.$const.CART_CODE.INVALIDHUTDAY:
                vm.$notify({
                  type: 'error',
                  title: message2
                })
                break
              case vm.$const.CART_CODE.INVALIDLUNCHTIME:
                vm.$notify({
                  type: 'error',
                  title: message1
                })
                break
              case vm.$const.CART_CODE.NOTFOUND:
                self.commit(vm, [])
                vm.$root.$emit('onRedirectToHome')
                break
              case vm.$const.CART_CODE.INVALIDORDERTIME:
                vm.$notify({
                  type: 'error',
                  title: message3
                })
                break
              case vm.$const.CART_CODE.INVALIDOPENTIME:
                vm.$notify({
                  type: 'error',
                  title: message4
                })
                break
              case vm.$const.CART_CODE.INVALIDMINCART:
                vm.$notify({
                  type: 'error',
                  title: message5
                })
                break
              case vm.$const.CART_CODE.EMPTYCART:
                vm.$notify({
                  type: 'error',
                  title: message6
                })
                break
              case vm.$const.CART_CODE.INVALIDCURRENTORDERTIME:
                vm.$notify({
                  type: 'error',
                  title: message7
                })
                break
              default:
                break
            }
          }
        )
      },
      getUpdateCartDetail: function (vm) {
        let cart = this.get(vm)
        let self = this
        if (!cart.uuid) {
          return false
        }

        let item = {}
        item.cart_uuid = cart.uuid

        vm.axios.apiCart.updateCartData(item,
          function (response) {
            cart = response.data.data.item
            self.commit(vm, cart)
          }, function (data) {
          }
        )
      },
      updateOrderTime: function (vm, item) {
        let cart = this.get(vm)
        let self = this

        if (!cart.uuid) {
          return false
        }
        item.cart_uuid = cart.uuid

        item.order_time = vm.convertDateTimeToUTC(item.order_time)

        vm.axios.apiCart.updateCartData(item,
          function (response) {
            cart = response.data.data.item
            self.commit(vm, cart)
          }, function (data) {
          }
        )
      },
      updateCartUuid: function (vm) {
        let cart = this.get(vm)
        if (!cart.uuid) {
          return false
        }

        let item = {}
        item.cart_uuid = cart.uuid

        if (cart.hasOwnProperty('is_use_cutlery')) {
          item.require_cutlery = cart.is_use_cutlery
        }

        vm.axios.apiCart.updateCartData(item,
          function (response) {
          }, function (data) {
          }
        )
      },
      processApplyCoupon (vm, data, type) {
        var cart = this.get(vm)
        let self = this
        if (!cart.uuid) {
          let params = {
            outlet_code: vm.$disposition.getByKey(vm, 'outletCode'),
            order_type: vm.$disposition.getByKey(vm, 'orderType', 'D').charAt(0),
            order_time: vm.convertDateTimeFromTimezoneToUTC(vm.$disposition.getByKey(vm, 'timezone', ''), vm.$disposition.getByKey(vm, 'collectionTimeValue', '')),
            advance_order: vm.$disposition.getByKey(vm, 'advanceOrder', 0)
          }
          vm.axios.apiCart.createCart(params,
            function (response) {
              data.cart_id = response.data.data.item.uuid
              cart.uuid = response.data.data.item.uuid
              self.commit(vm, cart)
              self._processApplyCoupon(vm, data, type)
            }, function (error) {
              self._processApplyCoupon(vm, data, type)
            }
          )
        } else {
          this._processApplyCoupon(vm, data, type)
        }
      },
      _processApplyCoupon (vm, data, type) {
        let cart = this.get(vm)
        let self = this
        var title = vm.$t('cart.apply_coupon_success')
        vm.axios.apiCart.applyCoupon(data,
          function (response) {
            vm.$emit('close')
            cart = response.data.data.item
            let coupons = {
              menu: cart.free_items,
              coupon: data.coupon_code
            }
            let layer = {name: '', couponCode: data.coupon_code, price: 0}
            if (coupons.menu && coupons.menu.length > 0) {
              layer.name = coupons.menu[0].name
              layer.price = coupons.menu[0].price
            }
            vm.eventTrackingCoupon(vm, layer)
            self.commit(vm, cart, coupons)
            if (response.data.data.info.hasOwnProperty('topping') && !vm.empty(response.data.data.info.topping)) {
              let title = vm.$t('message')
              let name = response.data.data.info.topping.name
              let price = response.data.data.info.topping.price
              if (!isNaN(price)) {
                price = vm.formatNumDisplay(price)
              }
              if (name && name.length > 0) {
                name = name.join(', ')
              } else {
                name = ''
              }
              let message = vm.$t('coupon_free_topping', {name: name, price: price, currency_unit: vm.$const.CURRENCY})
              vm.$root.$emit('onShowNotification', title, message)
            }
            vm.$notify({
              type: 'success',
              title: title
            })
          }, function (error) {
            if (error.status === false) {
              // mapping message
              let message = vm.getMessageFromGms(error)
              let coupon = vm.$const.COUPON_ALLOW[error.error.code]
              if ((coupon && coupon.fields && typeof coupon.fields !== 'undefined') || !message) {
                message = error.error ? error.error.message : ''
              }
              if (type == 'list') {
                vm.$notify({
                  type: 'error',
                  title: message
                })
              } else {
                vm.$store.commit('setCouponMessage', message)
              }
            } else {
              vm.$store.commit('setCouponMessage', '')
            }
          }
        )
      },
      applyCoupon: function (vm, data) {
        this.processApplyCoupon(vm, data, 'single')
      },
      applyCouponFromList: function (vm, data) {
        this.processApplyCoupon(vm, data, 'list')
      },
      removeCoupon: function (vm, data) {
        let cart = this.get(vm)
        let self = this
        var title = vm.$t('cart.remove_coupon_success')
        if (cart.uuid) {
          data.cart_id = cart.uuid
        }
        vm.axios.apiCart.removeCoupon(data,
          function (response) {
            vm.$emit('close')
            cart = response.data.data.item
            self.commit(vm, cart)
            vm.$notify({
              type: 'success',
              title: title
            })
          }
        )
      },
      updateQuantity: function (vm, data) {
        let cart = this.get(vm)
        let self = this
        var title = vm.$t('cart.update_quantity_success')
        if (cart.uuid) {
          data.cart_uuid = cart.uuid
        }
        vm.axios.apiCart.updateCartQuantity(data,
          function (response) {
            vm.$emit('close')
            cart = response.data.data.item
            self.commit(vm, cart)
            vm.$notify({
              type: 'success',
              title: title
            })
          }, function (error) {
            vm.$emit('close')
            vm.$notify({
              type: 'error',
              title: (error && error.error.message) || ''
            })
          }
        )
      },
      // remove item from cart
      remove: function (vm, id) {
        let data = {}
        let self = this
        let cart = this.get(vm)
        data['cart_id'] = cart.uuid
        let items = cart.data
        let newitems = []

        for (let i = 0; i < items.length; i++) {
          if (items[i].id != id) {
            newitems.push(items[i])
          }
        }
        cart.data = newitems

        // Send to API
        // Received response from API and set for cart
        data['item_id'] = id
        vm.axios.apiCart.removeCart(data, function (response) {
          cart = response.data.data.item
          self.commit(vm, cart)
        }, function (data) {
          if ([vm.$const.CART_CODE.NOTFOUND].indexOf(data.error.code) >= 0) {
            self.commit(vm, [])
            vm.$root.$emit('onRedirectToHome')
          }
        })
      },
      removeAll: function (vm, callback) {
        let data = {}
        let self = this
        let cart = this.get(vm)

        if (cart && cart.uuid) {
          vm.axios.apiCart.removeCartByUuid(cart.uuid, function (response) {
            cart = {}
            self.commit(vm, cart)

            if (callback) {
              callback(null, true)
            }
          }, function (data) {
            if ([vm.$const.CART_CODE.NOTFOUND].indexOf(data.error.code) >= 0) {
              self.commit(vm, [])

              if (callback) {
                callback(data.error.code, null)
              }
            }
          })
        } else {
          callback(false, null)
        }
      },
      clearFreeItem: function (vm) {
        let cart = this.get(vm)
        delete cart['current_coupon_item']
        cart.free_items = []
        this.commit(vm, cart, null, true)
      },
      commit: function (vm, cart, coupon, hideTracking = false) {
        if (!cart || vm.empty(cart)) {
          vm.$session.set('cart', {})
          vm.$root.$emit('cartUpdate', this.get(vm))
        } else {
          cart.current_coupon_item = {}
          if (coupon && coupon.menu && coupon.menu.length > 0) {
            cart.current_coupon_item = {
              'uuid': coupon.menu[0].uuid,
              'is_combo': coupon.menu[0].is_combo || false,
              'coupon': coupon.coupon,
              'menu': coupon.menu
            }
          }
          vm.$session.set('cart', cart)
          vm.cart = cart
          // Check enable or disable hut reward items
          setTimeout(() => {
            let isFreeItem = false
            if (vm.cart && vm.cart.data && vm.cart.data.length !== 0) {
              const freeItems = vm.cart.data.filter(item => item.menu_type === vm.$const.CARD_ITEM_TYPE.FREE)
              const maxItemHutReward = vm.$store.getters.getMaxItemHutReward
              if (freeItems && freeItems.length >= maxItemHutReward) {
                isFreeItem = true
              }
            }
            vm.$store.commit('setDisableItemHutReward', isFreeItem)
          }, 500)
          vm.$root.$emit('cartUpdate', cart.data)
          if (coupon && coupon.menu && coupon.menu.length > 0) {
            vm.$root.$emit('couponItemImplement', cart.current_coupon_item)
          }
        }

        if (typeof hideTracking === 'undefined' || !hideTracking) {
          vm.eventTrackingLoadCart(vm)
        }
      },
      getToppingById: function (a) {
        let arr = []
        for (let i = 0; i < a.length; i++) {
          arr.push(a[i].id)
        }
        return arr
      },
      checkout: function (vm, cardUUID, orderTime, orderPage = false, oldServiceFee = -1) {
        let data = {}
        let self = this
        data['cart_uuid'] = cardUUID
        data['order_time'] = orderTime
        vm.axios.apiCart.checkoutCartByUuid(data, (response) => {
          let cart = this.get(vm)
          let responseServiceFee = response.data.data && response.data.data.item && response.data.data.item.service_fee ? response.data.data.item.service_fee.service_fee : -1
          let message = vm.getMessageFromGms({error: {code: vm.$const.CART_CODE.CART_SERVICE_CHANGE}})
          if (responseServiceFee !== -1) {
            cart['service_fee'] = response.data.data.item.service_fee.service_fee
            cart['service_fee_name'] = response.data.data.item.service_fee.service_fee_name
            vm.$session.set('cart', cart)
            vm.$modal.show('dialog', {
              text: message || vm.$t('cart.service_fee_change'),
              buttons: [
                {
                  title: vm.$t('button_close'),
                  handler: () => {
                    vm.$modal.hide('dialog')
                    if (orderPage) {
                      vm.$root.$emit('paymentCheckServiceFee')
                    } else {
                      vm.$root.$emit('getDetail')
                    }
                  }
                }
              ]
            })
          } else {
            if (orderPage) {
              if (oldServiceFee !== -1 && oldServiceFee !== cart.service_fee) {
                vm.$modal.show('dialog', {
                  text: message || vm.$t('cart.service_fee_change'),
                  buttons: [
                    {
                      title: vm.$t('button_close'),
                      handler: () => {
                        vm.$modal.hide('dialog')
                        vm.$root.$emit('paymentCheckServiceFee')
                      }
                    }
                  ]
                })
              } else {
                vm.$root.$emit('paymentCheckServiceFee')
              }
            } else {
              vm.$router.push({'name': 'checkout'})
            }
          }
        }, (errorResponse) => {
          const { error } = errorResponse
          vm.$root.$emit('getDetail')
          vm.getPlasticBag(vm)
          if (vm.isMobileApp()) {
            vm.$root.$emit('showHideCart', false)
          }
          // Process for case cart has some invalid items.
          if (error.code === 'CART-10') {
            vm.$notify({
              type: 'warn',
              title: vm.$t('cart.include_invalid_items')
            })
          } else if ([vm.$const.CART_CODE.NOTFOUND].indexOf(error.code) >= 0) {
            self.commit(vm, [])
            vm.$root.$emit('onRedirectToHome')
          }
        })
      },

      create(vm, payload, cbSuccess, cbError) {
        const cart = this.get(vm);
        vm.axios.apiCart.createCart(
          payload,
          (res) => {
            if (res.data && res.data.status) {
              const { item } = res.data.data;
              cart.uuid = item.uuid;
              vm.$session.set('cart', cart);
            }
            cbSuccess && cbSuccess(cart);
          },
          (err) => cbError && cbError(err)
        );
      },
    }
  }
}

export default Cart



// WEBPACK FOOTER //
// ./src/plugins/cart.js